import { Component, ReactNode, ErrorInfo } from 'react';

import { navigate } from '@reach/router';

interface IProps {
  children: ReactNode;
}

interface IState {
  hasError: boolean;
}

class ErrorBoundary extends Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);

    this.state = { hasError: false };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
    // We want to know what happened
    // tslint:disable:no-console
    console.log({ error, errorInfo });

    this.setState({ hasError: true });

    navigate('/error');
  }

  public render(): ReactNode {
    const { children } = this.props;

    return children;
  }
}

export default ErrorBoundary;
